<template>

    <div class="row">
        <div class="col-md-4 col-md-offset-4">
            <usergroup-form
                v-if="usergroup !== null"
                box-title="Gebruikersgroep bewerken"
                @updateUsergroups="$emit('updateUsergroups')"
                :usergroup="usergroup"
            ></usergroup-form>

            <usergroup-form
                v-else
                box-title="Gebruikersgroep toevoegen"
                @updateUsergroups="$emit('updateUsergroups')"
            ></usergroup-form>
        </div>
    </div>

</template>

<script>

import { mapGetters } from "vuex";
import UsergroupForm from "../../../components/HR/Usergroups/UsergroupForm";

export default {

    components: {
        UsergroupForm,
    },

    computed: {
        ...mapGetters([
            'getHrUsergroups',
        ]),

        usergroup() {
            if (!this.$route.params.uuid) {
                return null;
            }

            let usergroup = this.getHrUsergroups.filter(group => group.uuid === this.$route.params.uuid);

            return usergroup.length === 1 ?
                usergroup[0] :
                null;
        },
    },

    metaInfo: {
        title:'Usergroup form',
    },

    name:'HrUsergroupsForm',

}

</script>
